import { SupplierFormValues } from "./supplier/supplierTypes"
import { CompanyFormValues } from "./company/companyTypes"

export enum BusinessType {
    "PRIVATE_COMPANY" = "PRIVATE_COMPANY",
    "PRIVATE_PERSON" = "PRIVATE_PERSON",
    "PUBLIC_LIMITED_COMPANY" = "PUBLIC_LIMITED_COMPANY",
}

export enum AgreementOptions {
    "YES" = "YES",
    "NO" = "NO",
}
export enum CountryCode {
    "DK" = "DK",
}

export enum InvoiceType {
    "EAN_NUMBER" = "EAN_NUMBER",
    "EMAIL" = "EMAIL",
}

export enum EntityType {
    SUPPLIER = "SUPPLIER",
    MERCHANT = "MERCHANT",
    COMPANY = "COMPANY",
    TENANT = "TENANT",
    SERVICE_CENTER = "SERVICE_CENTER",
    USER = "USER",
}

export enum EntityTypeFilter {
    ALL = "ALL",
    SUPPLIER = "SUPPLIER",
    MERCHANT = "MERCHANT",
    COMPANY = "COMPANY",
    SERVICE_CENTER = "SERVICE_CENTER",
}

export type EntityHistory = Readonly<{
    created: CreatedType
    updated: CreatedType
}>

export type CreatedType = Readonly<{
    timestamp: string
    author: string
}>

export enum EntityStatus {
    ACTIVE = "Active",
    INACTIVE = "Inactive",
}

export type Entity = Readonly<{
    id: number
    uid: string
    name: string
    caseNumber?: string
    address: Address
    entityDetails: {
        numberOfConnectedMerchants: number
        numberOfConnectedCompanies: number
        numberOfConnectedSuppliers: number
    }
    type: EntityType
    isAgreementOwner: boolean
    alerts: Array<Alert>
    isActive: boolean
    userGroupId?: number
    companyId?: number
    companyUid?: string
    status: EntityStatus
}>

export type EntitySimple = Readonly<{
    id: number
    uid: string
    caseNumber: string
    name: string
}>

export type EntityWithExtendedDetails = Omit<Entity, "entityDetails"> & {
    entityDetails: EntityExtendedDetails
}

export type EntityExtendedDetails = Readonly<{
    connectedSuppliers: Array<ConnectedEntities>
    connectedDevices: Array<ConnectedEntities>
    connectedCompanies: Array<ConnectedEntities>
    connectedMerchants: Array<ConnectedEntities>
}>

export type ConnectedEntities = Readonly<{
    id: number
    name: string
    type: string
}>

export type Alert = Readonly<{
    value: string
    text: string
}>

export type Address = Readonly<{
    displayName: string
}>

export type EntityAddress = Readonly<{
    addressLines: [string, string?]
    postalCode: string
    city: string
    countryCode: CountryCode
}>

export type EntityContactDetails = Readonly<{
    name: string
    phone: string
    email: string
}>

export type EntityInvoiceDetails = Readonly<{
    endpoint: {
        type: InvoiceType
        eanNumber?: string
        email?: string
    }
    debitorNo?: string
    attention?: string
    poNumber?: string
    reminderEmail?: string
}>

export type EntityFormValues = SupplierFormValues | CompanyFormValues
